module.exports = __webpack_public_path__ + "media/application/images/icons/items-produce-pebble-dark-green-rgb-e1b35457a48648dd46e1726d86f3bb34.svg";